var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 539,
    viewBox: "0 0 532 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.999 204.862L377.394 166.515L377.394 -1.64964e-05L-1.17802e-05 269.5L377.394 539L377.394 372.485L539.999 334.138L539.999 204.862Z",
    fill: "url(#paint0_linear_392_662)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_392_662",
    x1: -0.0000117802,
    y1: 269.5,
    x2: 539.999,
    y2: 269.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSolutions);
export default __webpack_public_path__ + "static/media/left-arrow-solutions.8b31414cd935e7094f6c9ff3e8b2aeb7.svg";
export { ForwardRef as ReactComponent };